import { make } from 'vuex-pathify'

const state = {
  type: false,
  terminal: false,
  sort: 'recommended',
  map: false
};

const mutations = make.mutations(state);

const getters = {
  ...make.getters(state),
  isFiltered(state) {
    return state.terminal || state.type;
  },
}

export default {
  namespaced: true,
  getters,
  state,
  mutations,
};